import { Injectable } from '@angular/core';
import {
  AdministratorFacade,
  Helper,
  abbreviateCountryStr,
  getRolesAndPermission,
} from '@piqet-angular/data';
import {
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { ColDef } from 'ag-grid-community';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CityDataGridService {
  event: any;
  cityPayload: any;

  editCityData = new Subject<[any, any, any]>();
  cityObservable$ = this.editCityData.asObservable();

  deleteCityData = new Subject<[any, any, any]>();
  cityDeleteObservable$ = this.deleteCityData.asObservable();

  constructor(private swalService: SwalService) {}

  getCityColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'CountryName',
      headerName: 'Country name',
      field: 'countryName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      valueFormatter: (params: any) => abbreviateCountryStr(params.data?.countryName),
      cellRenderer: (params: any, pathName: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.innerHTML = `${abbreviateCountryStr(params.data?.countryName)}`;
        cellElement.style.cursor = 'pointer';
        cellElement.style.textDecoration = 'underline';
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          if (
            params.columnApi.columnModel.columnDefs[
              params.columnApi.columnModel.columnDefs.length - 1
            ].cellRendererParams?.showEdit
          )
            this.editCityData.next([
              params.data.id,
              'Review new city',
              location.href.split('/')[6],
            ]);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'StateName',
      headerName: 'State name',
      field: 'stateName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      filter: 'agTextColumnFilter',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'City name',
      field: 'name',
      cellClass: 'my-permission-cursor-pointer',
      // sort:'asc',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      filter: 'agTextColumnFilter',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      minWidth: grid_widths_map.sm_column_xxm,
      maxWidth: grid_widths_map.sm_column_xs,
      cellRendererParams: {
        showEdit: this.isAccess() ? this.isAccess().isEdit : true,
        showDelete: this.isAccess() ? this.isAccess().isDelete : true,
        editData: (data: any, pathName: any) => {
          this.editCityData.next([data.id, 'Review new city', pathName]);
        },
        deleteData: (data: any, pathName: any) => {
          this.deleteCityDataConfirmation(data.id, '/City/DeleteCity?id', pathName);
        },
      },
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });
    return colDef;
  }

  deleteCityDataConfirmation(data: any, customType: any, pathName: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteCityData.next([data, customType, pathName]);
      }
    });
  }

  isAccess = () => {
    return getRolesAndPermission(rolesModuleName.AdvancedCity, mainModuleName.advancedModule);
  };
}
